// extracted by mini-css-extract-plugin
module.exports = {"container":"_2mRSkoypx64EvP3UZAPCkK","secondaryText":"_3-F_k0qTXcHCdSHenpigrZ","mainText":"eQ3JwINJv1QmxOXO-N8it"};